import { useAuth } from '../../../contexts/authContext';
import { useProject } from '../../../hooks/useProjects';
import { useProgramWriteAccess } from '../../../pages/Delivery/Programs/programWriteAccess';
import { AUTH_PROJECT_WRITE, AUTH_RFI_WRITE, deliveryActionNeedsProgram, deliveryFileMetaByAction, verdictForGate } from './deliveryActionDestinations';
export function useDeliveryUploadAuthz(input) {
    const needsProgram = input.actions.some((a)=>deliveryActionNeedsProgram(a.action));
    const access = useProgramWriteAccess(needsProgram ? input.programId ?? '' : '');
    const uniqueProjectIds = [
        ...new Set((input.projectIds ?? (input.projectId ? [
            input.projectId
        ] : [])).map((id)=>id.trim()).filter(Boolean))
    ];
    const mixedProjects = uniqueProjectIds.length > 1;
    const project = useProject(!mixedProjects ? uniqueProjectIds[0] ?? null : null);
    const { user } = useAuth();
    const signedIn = Boolean(user?.id);
    const projectCanEdit = project.data?.role === 'owner' || project.data?.role === 'member';
    const loading = needsProgram && access.isLoading || !mixedProjects && uniqueProjectIds.length === 1 && project.isLoading;
    return {
        loading,
        verdict: (action)=>{
            const meta = deliveryFileMetaByAction[action];
            if (!meta) return {
                permitted: true
            };
            if (loading) return {
                permitted: false,
                reason: 'Checking permission…'
            };
            // One hook can load one project. Mixed-project cards let zou decide at Accept.
            if (mixedProjects && (meta.authzGate === AUTH_PROJECT_WRITE || meta.authzGate === AUTH_RFI_WRITE)) {
                return {
                    permitted: true
                };
            }
            return verdictForGate(meta.authzGate, {
                recordDocuments: access.recordDocuments,
                contractDocuments: access.contractDocuments,
                execution: access.execution,
                qualityScores: access.qualityScores,
                quality: access.quality,
                touchpoints: access.touchpoints,
                comment: access.comment,
                projectCanEdit,
                signedIn
            });
        }
    };
}
